import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { CartResult, getCart, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, GetCart } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = Handler<
    {
        shouldLoadFullCart?: boolean;
        replaceCart?: boolean;
        getPromotions?: boolean;
        getCartLines?: boolean;
        getCostCodes?: boolean;
    } & HasOnSuccess,
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;
export const GetCartCustom: HandlerType = async props => {
    if (!props.apiParameter.expand?.includes("paymentOptions")) {
        props.apiParameter.expand?.push("paymentOptions");
    }
    props.apiResult = await getCart(props.apiParameter);
};

replaceInChain(chain, GetCart, GetCartCustom);
